import React, { useState } from "react";

const ContactForm = ({ onSubmitForm }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [storedData, setStoredData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // store locally so it's ready to send to backend later
    setStoredData(formData);

    console.log("Contact form data:", formData);

    // simulate done
    setTimeout(() => {
      setIsSubmitting(false);
    }, 400);

    // reset form
    setFormData({
      name: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* glow orbs */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-10 md:py-16 flex justify-center items-center">
        <div
          className="w-full max-w-4xl bg-white/80 backdrop-blur-lg p-6 md:p-10 lg:p-12 rounded-3xl shadow-lg border border-[#5989C8]/20"
          data-aos="zoom-in-up"
        >
          <h2 className="text-center text-2xl md:text-3xl font-semibold text-slate-900">
            Send Us a Message
          </h2>
          <p className="font-light text-center text-[#737588] mt-4 mb-8 px-2 md:px-8">
            Have questions about our courses, internships, or programs? Fill out
            the form below and our team will reach out to you shortly.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name + Phone */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                className="p-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent text-sm md:text-base"
                required
              />
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                className="p-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent text-sm md:text-base"
                required
              />
            </div>

            {/* Email + Subject */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email ID"
                className="p-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent text-sm md:text-base"
                required
              />
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subject"
                className="p-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent text-sm md:text-base"
              />
            </div>

            {/* Message */}
            <div>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                rows={4}
                className="w-full p-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent text-sm md:text-base"
                required
              />
            </div>

            {/* Submit */}
            <div className="flex justify-center mt-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-gradient-to-r from-[#5989C8] to-[#064585] text-white px-12 md:px-16 py-3 rounded-full text-sm md:text-base font-medium tracking-wide shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed transition"
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
